import { FC, ReactNode } from 'react';

import { Image } from '@repo/ui/Image';

interface Props {
  microcopy: {
    icon: string;
    copy: ReactNode;
  }[];
}

export const AuthFormFooter: FC<Props> = ({ microcopy }) => {
  return (
    <ul className="flex flex-col gap-4">
      {microcopy.map(({ icon, copy }) => (
        <li key={icon} className="flex items-center gap-4">
          <div className="relative block size-12">
            <Image src={icon} width={48} height={48} alt="" className="absolute block size-full object-contain" />
          </div>
          <div className="c-fs-body2 font-extrabold">{copy}</div>
        </li>
      ))}
    </ul>
  );
};
